import { Button, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

const IssueCardDescription: FC<
  React.PropsWithChildren<IssueCardDescriptionProps>
> = ({ learnMoreUrl, children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.issueCardDescription}>
      <div className={classes.header}>
        <Typography variant='body2' color='text.secondary'>
          Description
        </Typography>
        {learnMoreUrl && (
          <Tooltip title={learnMoreUrl}>
            <Button
              href={learnMoreUrl}
              target='_blank'
              size='small'
              sx={{
                textTransform: 'none',
              }}>
              Learn More
            </Button>
          </Tooltip>
        )}
      </div>
      <Typography variant='body2' color='text.primary' mt={1} component='div'>
        <div dangerouslySetInnerHTML={{ __html: children }} />
      </Typography>
    </div>
  );
};

const useStyles = makeStyles()({
  issueCardDescription: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    minHeight: 40,
  },
});

export interface IssueCardDescriptionProps {
  learnMoreUrl?: string;
  children: string;
}

export default IssueCardDescription;
